import React, { useState } from "react"
import { connect } from "react-redux"
import { Row, Col, Card, Rate, Modal, AutoComplete, Button } from "antd"
import {
  CHECK_RESTAURANTS,
  ENTER_INFO,
  CHECK_BUTTON,
  NO_RESTAURANT,
  RESTAURANT_COUNT,
  YOUR_PARTNER_ADDRESS_LABEL,
  YOUR_ADDRESS_LABEL,
  BACK_FROM_CHECK_RESTAURANT,
} from "../../constants/messages"
import { fetchAddressAutoComplete } from "../../redux/actionCreators/auth"
import { checkCommonRestaurantsForUs } from "../../redux/actionCreators/planDinnner"
import "./CheckRestaurants.scss"
import _ from "../../utils/lodashUtils"
import RestaurantList from "../../components/RestaurantList/RestaurantList"
import { ArrowLeftOutlined } from "@ant-design/icons"

/* Do not delete:  When button in couplig page "CHECK_RESTAURANTS"
 is enabled,this component is used */
const CheckRestaurants = props => {
  const [address, setAddress] = useState("")
  const [addressOptions, setAddressOptions] = useState([])

  const [partnerAddress, setPartnerAddress] = useState("")
  const [partnerAddressOptions, setPartnerAddressOptions] = useState([])

  const [showMessage, setShowMessage] = useState(false)

  const {
    fetchAddressAutoComplete,
    checkCommonRestaurantsForUs,
    allCommonRestaurants,
  } = props
  const { Option } = AutoComplete

  const [restaurantsList, setRestaurantList] = useState([])

  const handleSearch = async value => {
    setAddress(value)
    if (value.trim()) {
      let addresses = await fetchAddressAutoComplete(value)
      setAddressOptions(addresses.data)
    }
  }

  const partnerAddressSearch = async value => {
    setPartnerAddress(value)
    if (value) {
      let addresses = await fetchAddressAutoComplete(value)
      setPartnerAddressOptions(addresses.data)
    }
  }

  const onSelect = value => {
    setAddress(value)
  }

  const partnerAddressSelect = value => {
    setPartnerAddress(value)
  }

  const children = addressOptions.map(address => (
    <Option key={address.id} value={address.description}>
      {address.description}
    </Option>
  ))

  const partnerOptions = partnerAddressOptions.map(address => (
    <Option key={address.id} value={address.description}>
      {address.description}
    </Option>
  ))

  const checkRestaurantsForUs = () => {
    checkCommonRestaurantsForUs(address, partnerAddress).then(success => {
      if (_.isEmpty(success)) setShowMessage(true)

      setRestaurantList(Object.values(success))
    })
  }
  return (
    <React.Fragment>
      <div id="CheckAllRestaurants">
        <div className="container">
          <div className="backBtn">
            <Button
              className="back-btn"
              onClick={() => props.history.push("/dashboard")}
            >
              <ArrowLeftOutlined /> {BACK_FROM_CHECK_RESTAURANT}
            </Button>
          </div>
          <div className="check-heading">
            <div className="headerText">{CHECK_RESTAURANTS}</div>
            <div className="infoText">{ENTER_INFO}</div>
            <div className="flex-row">
              <div className="flex-column">
                <label>{YOUR_ADDRESS_LABEL}</label>
                <AutoComplete
                  value={address}
                  className="search-bar"
                  onSearch={handleSearch}
                  onSelect={onSelect}
                  allowClear={true}
                >
                  {address ? children : null}
                </AutoComplete>
              </div>
              <div className="flex-column">
                <label>{YOUR_PARTNER_ADDRESS_LABEL}</label>
                <AutoComplete
                  value={partnerAddress}
                  className="search-bar"
                  onSearch={partnerAddressSearch}
                  onSelect={partnerAddressSelect}
                  allowClear={true}
                >
                  {partnerAddress ? partnerOptions : null}
                </AutoComplete>
              </div>
            </div>
            <Button
              type="primary"
              onClick={checkRestaurantsForUs}
              disabled={!address.trim() || !partnerAddress.trim()}
            >
              {CHECK_BUTTON}
            </Button>
          </div>
          <div></div>
        </div>
      </div>
      {restaurantsList.length > 0 ? (
        <div id="CommonRestaurantList">
          <div className="restaurant-open-text">
            {RESTAURANT_COUNT(restaurantsList.length)}
          </div>
          <RestaurantList
            restaurantsList={restaurantsList}
            showClosed={false}
            isPartnerAway={true}
            isSuggestRequired={false}
          ></RestaurantList>
        </div>
      ) : (
        showMessage && <div className="no-restaurants">{NO_RESTAURANT}</div>
      )}
    </React.Fragment>
  )
}

export default connect(null, {
  fetchAddressAutoComplete,
  checkCommonRestaurantsForUs,
})(CheckRestaurants)
